export const config = {
    API_URL:'https://backend.beta-staging.tripex.ai/client-service/api/v1',
    AUTH_SHARED_KEY:"WESeElSN8dd6rc1OIhefLhQArgg7yo7iDMa2dwo4zq4u7kYl6",
    SOURCE:'demo.tripex.ai'
}
